import { render, staticRenderFns } from "./CoapEventSourceCreateDialog.vue?vue&type=template&id=4d5c7d2a&"
import script from "./CoapEventSourceCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./CoapEventSourceCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports